// import { DefaultWebsocketClient } from '../modules/websocket/module';
import { createHashHistory } from 'history';
import _ from 'lodash';
import { accountState } from '../page/my-account/account-state';
import moment from 'moment';
import GlobalNotification from '../component/common/snackbar';
import i18n from '../i18n';

/**
 * 移除账户缓存
 * - 断开Websocket连接s
 * - 返回登录页面
 */
export function cleanAccountCache(loginPage?: boolean) {
    try {
        const accountType = _.clone(accountState.accountType);
        // 移除token 、账号信息
        if (loginPage) {
            accountType === 'ADMIN' ? createHashHistory().push('/admin')
                : accountType === 'RESELLER' ? createHashHistory().push('/reseller')
                    : createHashHistory().push('/staff');
        }
        accountState.clear()
    } catch (error) { }
}

/**
 * 判断token是否过期
 * @param token 
 */
export function checkToken(token: {
    accessToken: string;
    expiresIn: number;
    expiresInDate: string;
}) {
    if (token.accessToken) {
        // 有token
        if (token.expiresInDate && moment(new Date()).isAfter(token.expiresInDate)) {
            // token过期
            cleanAccountCache(true)
            GlobalNotification.error(i18n.t('general_text_Not_logged_in_for_a_long_time_need_to_log_in_again'))
        }
    } else {
        // 没有token
        const pathName = createHashHistory().location.pathname;
        // 如果不在登录页面则踢出去登录页面
        if (pathName.indexOf('staff') === -1 && pathName.indexOf('admin') === -1 && pathName.indexOf('reseller') === -1) {
            cleanAccountCache(true)
        }
    }
}

